/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Day
 */
export interface Day {
}

/**
 * Check if a given object implements the Day interface.
 */
export function instanceOfDay(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DayFromJSON(json: any): Day {
    return DayFromJSONTyped(json, false);
}

export function DayFromJSONTyped(json: any, ignoreDiscriminator: boolean): Day {
    return json;
}

export function DayToJSON(value?: Day | null): any {
    return value;
}

